import { makeStyles } from "@material-ui/core/styles";

const zipmap = require("zipmap");
const data = require("../assets/csvjson.json");

const drawerWidth = 120;

export function getComputedTranslateXY(obj) {
  const transArr = [];
  if (!window.getComputedStyle) return;
  const style = getComputedStyle(obj),
    transform = style.transform || style.webkitTransform || style.mozTransform;
  let mat = transform.match(/^matrix3d\((.+)\)$/);
  if (mat) return parseFloat(mat[1].split(", ")[13]);
  mat = transform.match(/^matrix\((.+)\)$/);
  if (mat) transArr.push(parseFloat(mat[1].split(", ")[4]));
  if (mat) transArr.push(parseFloat(mat[1].split(", ")[5]));
  return transArr;
}

export function isMobile() {
  let iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  if (iOS) {
    return true;
  } else {
    return false;
  }
}

export function isLandscape() {
  return window.matchMedia("(orientation: landscape)").matches;
}
export const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flex: 1,
    maxWidth: "100%"
  },
  drawer: {
    [theme.breakpoints.up("md")]: {
      width: drawerWidth,
      flexShrink: 0
    }
  },
  appBar: {
    zIndex: 10000,
    height: 40,
    background: "rgb(82, 112, 181)"
  },
  toolBar: {
    justifyContent: "space-between"
  },
  timelineContainer: {
    paddingTop: 26,

    flex: 1
  },
  mapContainer: {
    paddingLeft: drawerWidth - 3,
    [theme.breakpoints.down("sm")]: {
      paddingLeft: 0
    }
  },
  fsButton: {
    position: "fixed",
    zIndex: 1000,
    [theme.breakpoints.down("md")]: {
      display: "none"
    }
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
      display: "none"
    }
  },
  logo: {
    width: 424,
    [theme.breakpoints.down("sm")]: {
      width: "75vw"
    }
  },
  // toolbar: theme.mixins.toolbar,
  toolbar: {
    paddingTop: 30
  },
  drawerPaper: {
    width: drawerWidth,
    background: "#fff",
    [theme.breakpoints.down("sm")]: {
      background: "#FFF"
    }
  },
  listItem: {
    paddingTop: 0,
    paddingBottom: 0
  },
  infoPaper: {
    width: "50%",
    [theme.breakpoints.down("md")]: {
      width: "75%"
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  closeBtn: {
    position: "absolute",
    right: 20,
    marginTop: -10
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3)
  }
}));

export const image_urls = data.map(json => json["Image Name"]);

export const Engines_zmap = zipmap(
  data.map(json => json["Engine AltName"]),
  data
);
